// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `You're in the draw, this was worth ${i.count} ${i.entries}!`
};

const de_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Du bist im Lostopf, das waren ${i.count} ${i.entries}!`
};

const es_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `¡Estás en el sorteo, esto valía ${i.count} ${i.entries}!`
};

const fr_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Vous êtes inscrit ! Cela vous a donné ${i.count} ${i.entries} !`
};

const fi_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Olet mukana arvonnassa, sait tästä ${i.count} ${i.entries}!`
};

const hi_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `आप ड्रॉ में हैं, इसकी कीमत ${i.count} ${i.entries} थी!`
};

const ja_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `抽選に参加しました。これは${i.count}${i.entries}の価値がありました！`
};

const nl_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Je doet mee aan de loting, dit was ${i.count} ${i.entries} waard!`
};

const pt_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Está no sorteio, isto valeu ${i.count} ${i.entries}!`
};

const ro_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Ești în tragere, aceasta valorează ${i.count} ${i.entries}!`
};

const th_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `คุณได้เข้าร่วมการจับรางวัลแล้ว นี่มีมูลค่า ${i.count} ${i.entries}!`
};

const ur_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `آپ قرعہ اندازی میں شامل ہیں، یہ ${i.count} ${i.entries} کے قابل تھا!`
};

const zh_hant1_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `您已成功參與抽獎，此操作價值 ${i.count} ${i.entries}！`
};

const da_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Du er med i lodtrækningen, dette var værd ${i.count} ${i.entries}!`
};

const it_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Sei nell'estrazione, questo valeva ${i.count} ${i.entries}!`
};

const vn_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Bạn đã tham gia rút thăm, điều này có giá trị ${i.count} ${i.entries}!`
};

const ko_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `추첨에 참여했습니다. 이것은 ${i.count}${i.entries}의 가치가 있었습니다!`
};

const tr_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Çekilişe katıldınız, bu ${i.count} ${i.entries} değerindeydi!`
};

const lv_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Jūs esat izlozē, tas bija vērts ${i.count} ${i.entries}!`
};

const ar_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `أنت في السحب، هذا يستحق ${i.count} ${i.entries}!`
};

const bs_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `U žrebanju ste, ovo je vrijedilo ${i.count} ${i.entries}!`
};

const sl_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Sodelujete v žrebanju, to je bilo vredno ${i.count} ${i.entries}!`
};

const id_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Anda sudah masuk undian, ini bernilai ${i.count} ${i.entries}!`
};

const sv_widget_action_completed = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Du är med i dragningen, detta var värt ${i.count} ${i.entries}!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown>, entries: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_action_completed = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_action_completed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_action_completed", locale)
	if (locale === "en") return en_widget_action_completed(inputs)
	if (locale === "de") return de_widget_action_completed(inputs)
	if (locale === "es") return es_widget_action_completed(inputs)
	if (locale === "fr") return fr_widget_action_completed(inputs)
	if (locale === "fi") return fi_widget_action_completed(inputs)
	if (locale === "hi") return hi_widget_action_completed(inputs)
	if (locale === "ja") return ja_widget_action_completed(inputs)
	if (locale === "nl") return nl_widget_action_completed(inputs)
	if (locale === "pt") return pt_widget_action_completed(inputs)
	if (locale === "ro") return ro_widget_action_completed(inputs)
	if (locale === "th") return th_widget_action_completed(inputs)
	if (locale === "ur") return ur_widget_action_completed(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_action_completed(inputs)
	if (locale === "da") return da_widget_action_completed(inputs)
	if (locale === "it") return it_widget_action_completed(inputs)
	if (locale === "vn") return vn_widget_action_completed(inputs)
	if (locale === "ko") return ko_widget_action_completed(inputs)
	if (locale === "tr") return tr_widget_action_completed(inputs)
	if (locale === "lv") return lv_widget_action_completed(inputs)
	if (locale === "ar") return ar_widget_action_completed(inputs)
	if (locale === "bs") return bs_widget_action_completed(inputs)
	if (locale === "sl") return sl_widget_action_completed(inputs)
	if (locale === "id") return id_widget_action_completed(inputs)
	if (locale === "sv") return sv_widget_action_completed(inputs)
	return "widget_action_completed"
};